<template>
  <div>
    <v-row>
      <v-col cols="12" sm="8">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Search"
          single-line
          outlined
          rounded
          dense
          hide-details
        ></v-text-field
      ></v-col>
      <v-col cols="12" sm="4">
          <v-btn
            color="primary"
            small
            tile
            outlined
            depressed
            @click="goToNewProvider"
            ><v-icon small>mdi-plus</v-icon> New Provider</v-btn
          >
          <import-provider-modal></import-provider-modal></v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="providers"
      :search="search"
      @click:row="(item) => goToProvider(item)"
      style="cursor: pointer"
      class="alt-shading"
    >
      <template v-slot:no-results
        ><v-card
          flat
          dense
          @click="goToNewProvider"
          class="text-center text-decoration-underline"
          ><v-card-text><v-btn small>New Provider</v-btn></v-card-text></v-card
        >
      </template></v-data-table
    >
  </div>
</template>

<script>
import ProviderForm from "./provider-form";
import ImportProviderModal from "./import-provider-modal";

export default {
  components: {
    ProviderForm,
    ImportProviderModal,
  },
  data() {
    return {
      headers: [
        {
          text: "Provider Id",
          value: "providerId",
        },
        {
          text: "Legacy Provider Id",
          value: "legacyProviderId",
          align: "left",
        },
        { text: "First Name", value: "firstName" },
        { text: "Last Name", value: "lastName" },
        { text: "Email Address", value: "emailAddress" },
      ],
      search: "",
    };
  },
  computed: {
    providers() {
      return this.$store.state.optionsModule.providers || [];
    },
  },
  methods: {
    goToProvider(item) {
      this.$router.push({
        name: "ProviderForm",
        params: { providerId: item.providerId },
      });
    },
    goToNewProvider() {
      this.$router.push({
        name: "NewProvider",
      });
    },
  },
};
</script>

<style lang="css" scoped>
.alt-shading >>> tr:nth-child(even) {
  background: #ccc;
}
</style>